"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeBooleanRe = exports.makeReGroup = void 0;
var tslib_1 = require("tslib");
var trueStrings = ["true", "on", "✓", "✔", "🗸", "🗹", "☑", "✅"];
var falseStrings = ["false", "off", "⍻", "X"];
/**
 * Creates a regular expression that will match if tested against a string
 * containing any of the strings in the input array.
 * @param strings An array of strings
 * @param exclusive Set to true to start regex with "^" and end with "$", false (or omit) otherwise.
 * @example
 * const trueStrings = ["true", "on", "1", "✓", "✔", "🗸", "🗹", "☑", "✅"];
 * const falseStrings = ["false", "off", "0", "⍻", "X"];
 * const trueRe = makeReGroup(trueStrings);
 * // /(?:true)|(?:on)|(?:1)|(?:✓)|(?:✔)|(?:🗸)|(?:🗹)|(?:☑)|(?:✅)/
 * const falseRe = makeReGroup(falseStrings);
 * // /(?:false)|(?:off)|(?:0)|(?:⍻)|(?:X)/
 */
function makeReGroup(strings, exclusive) {
    var pattern = strings.map(function (s) { return "(?:".concat(s, ")"); }).join("|");
    if (exclusive) {
        pattern = "^(?:".concat(pattern, ")$");
    }
    return new RegExp("".concat(pattern), "i");
}
exports.makeReGroup = makeReGroup;
/**
 * Creates a RegExp that will match boolean values.
 * @param matchOnly Set to true to only match true value strings.
 * Set to false to only match false value strings.
 * Set to non-boolean (e.g., undefined or null) to match either true or false.
 * @param exclusive
 */
function makeBooleanRe(matchOnly, exclusive) {
    var parts = matchOnly === true
        ? trueStrings
        : matchOnly === false
            ? falseStrings
            : trueStrings.concat.apply(trueStrings, tslib_1.__spreadArray([], tslib_1.__read(falseStrings), false));
    return makeReGroup(parts, exclusive);
}
exports.makeBooleanRe = makeBooleanRe;
